import {
  Action,
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';

import { News } from '../@models/news.model';
import * as actions from './news.actions';

export interface State {
  news: News[];
  isNewsReady: boolean;
}

const initialState: State = {
  news: [],
  isNewsReady: false,
};

const newsReducers = createReducer(
  initialState,
  on(actions.requestNews, (state) => ({
    ...state,
    news: [],
    isNewsReady: false,
  })),
  on(actions.newsReceived, (state, action) => ({
    ...state,
    news: action.items.map((item) => new News(item)),
    isNewsReady: true,
  })),
  on(actions.newsReceiveFailed, (state) => ({
    ...state,
    isNewsReady: true,
  }))
);

export function reducer(state: State | undefined, action: Action): State {
  return newsReducers(state, action);
}

export const newsReducer = reducer;
export const newsFeatureKey = 'news';

export const newsState = createFeatureSelector<State>(newsFeatureKey);

export const getNews = createSelector(newsState, (state) => state.news);

export const isNewsReady = createSelector(
  newsState,
  (state) => state.isNewsReady
);
